import { lazy_apply_setter } from 'console/redux/data-utils';
import { createHistoryMaintenanceRedux, deleteHistoryMaintenanceRedux, editHistoryMaintenanceRedux, } from 'console/tabs/maintenance/Actions_Reducers/maintenance-reducers-functions';
import { deviceFromJSON, devicesFromJSON, resolveRerender } from 'console/device/utils';
function deviceReducerWithoutIconState(device, action) {
    if ('device_id' in action && action.device_id === device.id) {
        switch (action.type) {
            case 'OBEY_ONLY_LAST_RESPONSE': {
                const new_obey_only_last_response = {
                    ...device._ignore_responses_earlier_than,
                };
                for (const field of action.fields) {
                    new_obey_only_last_response[field] = action.request_code;
                }
                return {
                    ...device,
                    _ignore_responses_earlier_than: new_obey_only_last_response,
                };
            }
            case 'APPLY_DEVICE_UPDATE': {
                // ATTENTION! setter maybe part of part device
                let setter = { ...action.setter };
                if (action.request_code) {
                    for (const field of Object.keys(action.setter)) {
                        if (device._ignore_responses_earlier_than &&
                            action.request_code <
                                device._ignore_responses_earlier_than?.[field])
                            //@ts-ignore
                            delete setter[field];
                    }
                }
                if (setter?.rf_status != null) {
                    const rf = {};
                    for (const s_serial of Object.keys(setter.rf_status || {})) {
                        rf[s_serial.replace(/^s_/, '')] = setter.rf_status[s_serial];
                    }
                    setter = { ...setter, rf_status: rf };
                }
                // We do all this operations below, because comet send new individual name for all users, but
                // we need to take it only if it is user's individual name/note
                // also we convert this object to a string (we take only name)
                if (setter?.individual_device_name) {
                    if (
                    // @ts-ignore
                    setter.individual_device_name.user_id === action.user_id) {
                        setter.individual_device_name =
                            // @ts-ignore
                            setter.individual_device_name.name;
                    }
                    else {
                        delete setter.individual_device_name;
                    }
                }
                if (setter?.individual_device_note) {
                    if (
                    // @ts-ignore
                    setter.individual_device_note.user_id === action.user_id) {
                        setter.individual_device_note =
                            // @ts-ignore
                            setter.individual_device_note.note;
                    }
                    else {
                        delete setter.individual_device_note;
                    }
                }
                if (setter?.name && !action.is_user_pro) {
                    setter.individual_device_name = setter.name;
                }
                if (setter.balance) {
                    setter.balance = { ...device.balance, ...setter.balance };
                }
                // TODO: don't use mergedeep from immutable js! he extends all arrays
                // need function, that merge setter correctly
                const result = { ...device, ...setter };
                return result;
            }
            case 'SET_DEVICE_ONLINE': {
                const setter = { online: action.online };
                if (!action.online) {
                    setter.last_connect_time = action.time;
                }
                else {
                    setter.just_installed_firmware = false;
                }
                return { ...device, ...setter };
            }
            case 'APPLY_TEMPERATURE_UPDATE':
                return {
                    ...device,
                    thermometers: (device.thermometers || []).map((thermometer) => {
                        const new_state = action.temperature[thermometer.uuid];
                        return new_state == null
                            ? thermometer
                            : {
                                ...thermometer,
                                last_state: new_state.state,
                                last_value: new_state.value,
                                last_value_time: action.time,
                            };
                    }),
                };
            case 'APPLY_NEW_RF_STATUSES': {
                const rf_status = { ...device.rf_status };
                for (const serial of Object.keys(action.rf || {}))
                    rf_status[serial] = {
                        ...rf_status[serial],
                        ...action.rf[serial],
                    };
                return { ...device, rf_status };
            }
            case 'APPLY_NEW_DATA': {
                const setter = {};
                if (action.data.last_receive_time != null) {
                    setter.last_receive_time = action.data.last_receive_time;
                }
                if (action.data.gps && action.data.gps?.length > 0) {
                    const new_points = [];
                    let time = null;
                    for (const [delta, x, y, speed, provider, single, accuracy, satellites, hdop, altitude, avg_va,] of action.data.gps) {
                        time = delta > 0 ? delta : (time ?? 0) - delta;
                        new_points.push({
                            time,
                            x,
                            y,
                            speed,
                            provider,
                            single,
                            accuracy,
                            satellites,
                            hdop,
                            altitude,
                            avg_va,
                        });
                    }
                    new_points.reverse();
                    setter.last_gps = [...new_points, ...(device.last_gps || [])];
                    setter.last_gps.sort((a, b) => b.time - a.time);
                    setter.last_gps = setter.last_gps.slice(0, 5);
                }
                if (action.data.otzones != null) {
                    const otzones_last_setter = {};
                    for (const [_zone_id, ot_arrs] of Object.entries(action.data.otzones)) {
                        const zone_id = +_zone_id;
                        for (const [name, values] of Object.entries(ot_arrs)) {
                            if (values.length > 0) {
                                if (otzones_last_setter[zone_id] == null) {
                                    otzones_last_setter[zone_id] = {};
                                }
                                otzones_last_setter[zone_id][name] =
                                    values[values.length - 1][1];
                            }
                        }
                    }
                    setter.otzones_last = lazy_apply_setter(device.otzones_last || {}, otzones_last_setter);
                }
                return lazy_apply_setter(device, setter);
            }
            case 'APPLY_FILETRANSFER_UPDATE': {
                let found = false;
                let just_installed_firmware = false;
                const filetransfers = device.filetransfers.map(function (existing) {
                    if (existing.id === action.transfer.id) {
                        found = true;
                        const cancelled = existing.cancelled || action.transfer.cancelled;
                        if (existing.type === 'firmware' &&
                            action.transfer.done &&
                            !cancelled) {
                            just_installed_firmware = true;
                        }
                        return { ...existing, ...action.transfer };
                    }
                    else {
                        return existing;
                    }
                });
                if (!found) {
                    filetransfers.push(action.transfer);
                }
                return { ...device, just_installed_firmware, filetransfers };
            }
            case 'START_RF_RELOAD':
                return {
                    ...device,
                    rf_updating: true,
                    rf_updating_successful: false,
                };
            case 'FINISH_RF_RELOAD':
                if (action.ok) {
                    return {
                        ...device,
                        rf_status: action.rf,
                        rf_updating: false,
                        rf_updating_successful: true,
                    };
                }
                else {
                    return {
                        ...device,
                        rf_updating: false,
                        rf_updating_successful: false,
                    };
                }
            case 'DEVICE_GUARD__REQUEST':
                return {
                    ...device,
                    guard_state__loading: true,
                    guard_state__fail: false,
                };
            case 'DEVICE_GUARD__FAIL':
                return {
                    ...device,
                    guard_state__loading: false,
                    guard_state__fail: true,
                    action_fail_message: action.error_message,
                };
            case 'DEVICE_GUARD__RESET':
                return {
                    ...device,
                    guard_state__loading: false,
                    guard_state__fail: false,
                    action_fail_message: '',
                };
            case 'DEVICE_ENGINE_BLOCK__REQUEST':
                return {
                    ...device,
                    engine_block__loading: true,
                    engine_block__fail: false,
                };
            case 'DEVICE_ENGINE_BLOCK__FAIL':
                return {
                    ...device,
                    engine_block__loading: false,
                    engine_block__fail: true,
                    action_fail_message: action.error_message,
                };
            case 'DEVICE_ENGINE_BLOCK__RESET':
                return {
                    ...device,
                    engine_block__loading: false,
                    engine_block__fail: false,
                    action_fail_message: '',
                };
            case 'DEVICE_SIREN__REQUEST':
                return { ...device, siren__loading: true, siren__fail: false };
            case 'DEVICE_SIREN__FAIL':
                return {
                    ...device,
                    siren__loading: false,
                    siren__fail: true,
                    action_fail_message: action.error_message,
                };
            case 'DEVICE_SIREN__RESET':
                return {
                    ...device,
                    siren__loading: false,
                    siren__fail: false,
                    action_fail_message: '',
                };
            case 'DEVICE_WEBASTO__REQUEST':
                return {
                    ...device,
                    webasto__loading: true,
                    webasto__fail: false,
                };
            case 'DEVICE_WEBASTO__FAIL':
                return {
                    ...device,
                    webasto__loading: false,
                    webasto__fail: true,
                    action_fail_message: action.error_message,
                };
            case 'DEVICE_WEBASTO__RESET':
                return {
                    ...device,
                    webasto__loading: false,
                    webasto__fail: false,
                    action_fail_message: '',
                };
            case 'DEVICE_AUTOSTART__REQUEST':
                return {
                    ...device,
                    auto_ignition__loading: true,
                    auto_ignition__fail: false,
                };
            case 'DEVICE_AUTOSTART__FAIL':
                return {
                    ...device,
                    auto_ignition__loading: false,
                    auto_ignition__fail: true,
                    action_fail_message: action.error_message,
                };
            case 'DEVICE_AUTOSTART__RESET':
                return {
                    ...device,
                    auto_ignition__loading: false,
                    auto_ignition__fail: false,
                    action_fail_message: '',
                };
            case 'SEND_CUSTOM_COMMAND__REQUEST': {
                return {
                    ...device,
                    custom_controls_elements__loading: {
                        ...device.custom_controls_elements__loading,
                        [action.element_no]: true,
                    },
                    custom_controls_elements__fail: {
                        ...device.custom_controls_elements__fail,
                        [action.element_no]: false,
                    },
                };
            }
            case 'SEND_CUSTOM_COMMAND__SUCCESS': {
                const element_no = (device.custom_controls ?? []).findIndex(({ commands }) => commands?.some(({ id }) => id === action.command_id));
                if (element_no != null) {
                    return {
                        ...device,
                        custom_controls_elements__loading: {
                            ...device.custom_controls_elements__loading,
                            [element_no]: false,
                        },
                        custom_controls_elements__fail: {
                            ...device.custom_controls_elements__fail,
                            [element_no]: false,
                        },
                    };
                }
                return device;
            }
            case 'SEND_CUSTOM_COMMAND__FAIL':
                return {
                    ...device,
                    custom_controls_elements__loading: {
                        ...device.custom_controls_elements__loading,
                        [action.element_no]: false,
                    },
                    custom_controls_elements__fail: {
                        ...device.custom_controls_elements__fail,
                        [action.element_no]: true,
                    },
                    custom_controls_elements__fail_message: {
                        ...device.custom_controls_elements__fail_message,
                        [action.element_no]: action.error_message,
                    },
                };
            case 'SEND_CUSTOM_COMMAND__RESET':
                return {
                    ...device,
                    custom_controls_elements__loading: {
                        ...device.custom_controls_elements__loading,
                        [action.element_no]: false,
                    },
                    custom_controls_elements__fail: {
                        ...device.custom_controls_elements__fail,
                        [action.element_no]: false,
                    },
                    custom_controls_elements__fail_message: {
                        ...device.custom_controls_elements__fail_message,
                        [action.element_no]: '',
                    },
                };
            case 'SET_SERVICE_MODE__MANUAL': {
                return {
                    ...device,
                    service_mode_manual: true,
                };
            }
            case 'REQUEST_RADIO_SILENCE':
                return {
                    ...device,
                    radiosilence_planned: action.is_radio_silence,
                };
            case 'FORMAT_FILESYSTEM__REQUEST':
                return { ...device, format_filesystem_state: 'request' };
            case 'FORMAT_FILESYSTEM__OK':
                return { ...device, format_filesystem_state: 'ok' };
            case 'FORMAT_FILESYSTEM__FAIL':
                return { ...device, format_filesystem_state: 'fail' };
            case 'FORMAT_FILESYSTEM__CLEAR':
                return { ...device, format_filesystem_state: null };
            case 'FORMAT_ZTC700__REQUEST':
                return { ...device, format_ztc700_state: 'request' };
            case 'FORMAT_ZTC700__OK':
                return { ...device, format_ztc700_state: 'ok' };
            case 'FORMAT_ZTC700__FAIL':
                return { ...device, format_ztc700_state: 'fail' };
            case 'FORMAT_ZTC700__CLEAR':
                return { ...device, format_ztc700_state: null };
            case 'FIX_HW205_AMR__REQUEST':
                return { ...device, fix_hw205_amr_state: 'request' };
            case 'FIX_HW205_AMR__OK':
                return { ...device, fix_hw205_amr_state: 'ok' };
            case 'FIX_HW205_AMR__FAIL':
                return { ...device, fix_hw205_amr_state: 'fail' };
            case 'FIX_HW205_AMR__CLEAR':
                return { ...device, fix_hw205_amr_state: null };
            case 'DOWNLOAD_L1000_LOG__REQUEST':
                return { ...device, download_l1000_log_state: 'request' };
            case 'DOWNLOAD_L1000_LOG__OK':
                return { ...device, download_l1000_log_state: 'ok' };
            case 'DOWNLOAD_L1000_LOG__FAIL':
                return { ...device, download_l1000_log_state: 'fail' };
            case 'DOWNLOAD_L1000_LOG__CLEAR':
                return { ...device, download_l1000_log_state: null };
            case 'SAVE_Z3K_SETTINGS__OK':
                return {
                    ...device,
                    z3k_config: { ...action.config },
                    config_write_status: device.online,
                };
            case 'CONFIG_END_WRITE':
                return {
                    ...device,
                    z3k_config: {
                        ...(device.z3k_config ?? {}),
                    },
                    config_write_status: false,
                };
            case 'UPLOAD_Z3K_CONFIG__OK':
                return { ...device, z3k_config: action.config };
            case 'APPLY_STOCK_CONFIG__OK':
                return { ...device, z3k_config: action.result_config };
            // case 'CLEAR_S62_SETTINGS':
            // case 'GOT_S62_SETTINGS_ANSWER':
            //     return {
            //         ...device,
            //         s62_params: a300_diag_settings_reducer(device.s62_params, action),
            //     };
            case 'RESET_THERMOMETERS_RESPONSE':
                return {
                    ...device,
                    thermometers: [],
                    thermometers_reset_in_progress: false,
                };
            case 'LOAD_THERMOMETERS__OK':
                return {
                    ...device,
                    thermometers: action.thermometers,
                    thermometers_reset_in_progress: false,
                };
            case 'CHANGE_SIM_IN_DEVICE':
                return { ...device, sim_in_device: action.sim_in_device };
            case 'ADD_HISTORY_MAINTENANCE':
                return {
                    ...device,
                    maintenances: createHistoryMaintenanceRedux(device.maintenances, action.maintenance),
                };
            case 'DELETE_HISTORY_MAINTENANCE':
                return {
                    ...device,
                    maintenances: deleteHistoryMaintenanceRedux(device.maintenances, action.maintenance_id),
                };
            case 'EDIT_HISTORY_MAINTENANCE':
                return {
                    ...device,
                    maintenances: editHistoryMaintenanceRedux(device.maintenances, action.maintenance),
                };
            // case 'CHANGE_MAINTENANCE_PLAN':
            //     return {
            //         ...device,
            //         maintenances: changeMaintenancePlanRedux(
            //             device.maintenances,
            //             action.plan_id
            //         ),
            //     };
            case 'SET_THERMOSTAT_MODES_ACTION__FAIL': {
                const thermostat_setter = { ...device.thermostat_ext_modes_config };
                thermostat_setter[action.object_id].fail = true;
                thermostat_setter[action.object_id].fail_message = action.error_message;
                return {
                    ...device,
                    thermostat_ext_modes_config: { ...thermostat_setter },
                };
            }
            case 'RESET_THERMOSTAT_MODES_ACTION__FAIL': {
                const thermostat_setter = { ...device.thermostat_ext_modes_config };
                thermostat_setter[action.object_id].fail = false;
                thermostat_setter[action.object_id].fail_message = '';
                return {
                    ...device,
                    thermostat_ext_modes_config: { ...thermostat_setter },
                };
            }
            case 'SET_THERMOSTAT_TEMPS_ACTION__FAIL': {
                const thermostat_setter = { ...device.thermostat_target_temps };
                thermostat_setter[action.object_id].fail = true;
                thermostat_setter[action.object_id].fail_message = action.error_message;
                return {
                    ...device,
                    thermostat_target_temps: { ...thermostat_setter },
                };
            }
            case 'RESET_THERMOSTAT_TEMPS_ACTION__FAIL': {
                const thermostat_setter = { ...device.thermostat_target_temps };
                thermostat_setter[action.object_id].fail = false;
                thermostat_setter[action.object_id].fail_message = '';
                return {
                    ...device,
                    thermostat_target_temps: { ...thermostat_setter },
                };
            }
            case 'APPLY_DECLINE_UPDATE_FIRMWARE_VERSION': {
                return {
                    ...device,
                    declined_firmware_update_versions: [
                        ...device.declined_firmware_update_versions,
                        action.decline_version,
                    ],
                };
            }
            default:
                return device;
        }
    }
    else {
        switch (action.type) {
            case 'APPLY_IO_PORTS': {
                const my_setter = action.devid2setter[device.id];
                if (my_setter != null) {
                    [
                        'guard_state',
                        'engine_block',
                        'siren',
                        'webasto',
                        'auto_ignition',
                    ].map((key) => {
                        if (key in my_setter) {
                            my_setter[`${key}__loading`] = false;
                            my_setter[`${key}__fail`] = false;
                        }
                    });
                    return { ...device, ...my_setter };
                }
                else {
                    return device;
                }
            }
            default:
                return device;
        }
    }
}
function deviceReducer(device, action) {
    return resolveRerender(deviceReducerWithoutIconState(device, action));
}
export function deviceItemsReducer(PRELOAD) {
    return (state, action) => {
        if (state == undefined) {
            return devicesFromJSON(PRELOAD.devices);
        }
        switch (action.type) {
            case 'DEVICE_ADDED':
                return [...state, deviceFromJSON(action.device)];
            case 'DEVICE_DELETED':
                return state.filter((dev) => dev.id !== action.device_id);
            case 'APPLY_DEVICES_JSON':
                return devicesFromJSON(action.devices_json);
            case 'APPLY_DEVICE_UPDATE':
            case 'OBEY_ONLY_LAST_RESPONSE':
            case 'SET_DEVICE_ONLINE':
            case 'APPLY_TEMPERATURE_UPDATE':
            case 'APPLY_NEW_RF_STATUSES':
            case 'APPLY_NEW_DATA':
            case 'APPLY_FILETRANSFER_UPDATE':
            case 'START_RF_RELOAD':
            case 'FINISH_RF_RELOAD':
            case 'DEVICE_GUARD__REQUEST':
            case 'DEVICE_GUARD__FAIL':
            case 'DEVICE_GUARD__RESET':
            case 'DEVICE_ENGINE_BLOCK__REQUEST':
            case 'DEVICE_ENGINE_BLOCK__FAIL':
            case 'DEVICE_ENGINE_BLOCK__RESET':
            case 'DEVICE_SIREN__REQUEST':
            case 'DEVICE_SIREN__FAIL':
            case 'DEVICE_SIREN__RESET':
            case 'DEVICE_WEBASTO__REQUEST':
            case 'DEVICE_WEBASTO__FAIL':
            case 'DEVICE_WEBASTO__RESET':
            case 'DEVICE_AUTOSTART__REQUEST':
            case 'DEVICE_AUTOSTART__FAIL':
            case 'DEVICE_AUTOSTART__RESET':
            case 'SEND_CUSTOM_COMMAND__REQUEST':
            case 'SET_SERVICE_MODE__MANUAL':
            case 'SEND_CUSTOM_COMMAND__SUCCESS':
            case 'SEND_CUSTOM_COMMAND__FAIL':
            case 'SEND_CUSTOM_COMMAND__RESET':
            case 'REQUEST_RADIO_SILENCE':
            case 'FORMAT_FILESYSTEM__REQUEST':
            case 'FORMAT_FILESYSTEM__OK':
            case 'FORMAT_FILESYSTEM__FAIL':
            case 'FORMAT_FILESYSTEM__CLEAR':
            case 'FORMAT_ZTC700__REQUEST':
            case 'FORMAT_ZTC700__OK':
            case 'FORMAT_ZTC700__FAIL':
            case 'FORMAT_ZTC700__CLEAR':
            case 'FIX_HW205_AMR__REQUEST':
            case 'FIX_HW205_AMR__OK':
            case 'FIX_HW205_AMR__FAIL':
            case 'FIX_HW205_AMR__CLEAR':
            case 'DOWNLOAD_L1000_LOG__REQUEST':
            case 'DOWNLOAD_L1000_LOG__OK':
            case 'DOWNLOAD_L1000_LOG__FAIL':
            case 'DOWNLOAD_L1000_LOG__CLEAR':
            case 'SAVE_Z3K_SETTINGS__OK':
            case 'CONFIG_END_WRITE':
            case 'UPLOAD_Z3K_CONFIG__OK':
            case 'APPLY_STOCK_CONFIG__OK':
            case 'RESET_THERMOMETERS_RESPONSE':
            case 'LOAD_THERMOMETERS__OK':
            case 'CHANGE_SIM_IN_DEVICE':
            case 'ADD_HISTORY_MAINTENANCE':
            case 'DELETE_HISTORY_MAINTENANCE':
            case 'EDIT_HISTORY_MAINTENANCE':
            case 'SET_THERMOSTAT_MODES_ACTION__FAIL':
            case 'RESET_THERMOSTAT_MODES_ACTION__FAIL':
            case 'SET_THERMOSTAT_TEMPS_ACTION__FAIL':
            case 'RESET_THERMOSTAT_TEMPS_ACTION__FAIL':
            case 'APPLY_DECLINE_UPDATE_FIRMWARE_VERSION':
            case 'CHANGE_MAINTENANCE_PLAN': {
                return state.map((dev) => dev.id === action.device_id ? deviceReducer(dev, action) : dev);
            }
            case 'APPLY_IO_PORTS':
            case 'FORCE_UPDATE_STATE':
                return state.map((dev) => deviceReducer(dev, action));
            case 'APPLY_MANY_NEW_DATA':
                return state.map((dev) => {
                    if (!action.map[dev.id]) {
                        return dev;
                    }
                    for (const msg of action.map[dev.id]) {
                        dev = deviceReducer(dev, {
                            type: 'APPLY_NEW_DATA',
                            device_id: dev.id,
                            data: msg,
                        });
                    }
                    return dev;
                });
            default:
                return state;
        }
    };
}
